import { emitter } from 'shared/helpers/mitt';
import { BUS_EVENTS } from 'shared/constants/busEvents';

export const useToast = () => {
  const showToast = (message, options = {}) => {
    emitter.emit(BUS_EVENTS.SHOW_TOAST, {
      message,
      action: options,
    });
  };

  return { showToast };
};

export default useToast;
